import React from "react";
import styled from "styled-components";
import { style } from "../style";

import { Icon } from "../Icon";
import { useEvent } from "../hooks/useEvent";

type Props = React.PropsWithChildren<{
  type: keyof typeof typeMap;
  onClose: () => void;
}>;

type ContainerProps = {
  $borderColor: string;
};

const Container = styled.div<ContainerProps>`
  all: unset;

  display: flex;
  align-items: center;
  gap: ${style.vars.space[3]};

  padding: ${style.vars.space[3]};

  background-color: ${style.colors.white};

  border: 1px solid ${(p) => p.$borderColor};
  border-radius: ${style.vars.borderRadius.base};

  box-shadow: 0px 2px 6px 0px #031b4e4d, 0px 4px 4px 0px #031b4e1a;
`;

const IconWrapper = styled.div`
  all: unset;

  min-width: ${style.vars.space[5]};
  flex-grow: 0;
  line-height: ${style.vars.lineHeight};
`;

const ChildrenWrapper = styled.div`
  all: unset;

  flex-grow: 1;
  line-height: ${style.vars.lineHeight};
`;

const CloseButton = styled.button`
  all: unset;

  min-width: ${style.vars.space[5]};
  flex-grow: 0;
  line-height: ${style.vars.lineHeight};

  pointer-events: auto;
  cursor: pointer;
`;

const typeMap = {
  success: {
    icon: "alert-success",
    color: style.colors.green.dark,
  },
  error: {
    icon: "alert-error",
    color: style.colors.red.dark,
  },

  info: {
    icon: "alert-info",
    color: style.colors.blue.dark,
  },
};

export const Toast: React.FC<Props> = (props) => {
  const type = typeMap[props.type ?? "success"];

  const onClose = useEvent((ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    props.onClose();
  });

  return (
    <Container $borderColor={type.color}>
      <IconWrapper>
        <Icon icon={type.icon} svgProps={{ color: type.color }} large />
      </IconWrapper>

      <ChildrenWrapper>{props.children}</ChildrenWrapper>

      <CloseButton aria-label="Close" onClick={onClose}>
        <Icon icon="close" />
      </CloseButton>
    </Container>
  );
};
